let width = $(window).width();

if (width < 1200) {
  $(".hamburger").click(function (e) {
    e.stopPropagation();
    $(".nav-main").fadeToggle("fast");
  });

  $(document).click(function (e) {
    if (!$(e.target).closest("nav").length) {
      $(".nav-main").fadeOut();
    }
  });

  $(".btn-settings").click(function (e) {
    $(".nav-main").fadeOut();
  });
}

$(window).scroll(function () {
  if ($(window).scrollTop() > 10) {
    $(".header").addClass("sticky");
  } else if ($(window).scrollTop() <= 10) {
    $(".header").removeClass("sticky");
  }
});

$("#menu-menu-glowne li a").click(function (e) {
  if ($(this).attr("href") == "#") {
    e.preventDefault();
  }
});
